import { FecImportAnalysisErrorCode } from '../enums/fecImportAnalysisErrorCode'
import { FecImportConfirmationKind } from '../enums/fecImportConfirmationKind'
import type { FecImportItem } from '../query-api'
import { getFecImportAnalysisErrorCode } from './getFecImportAnalysisErrorCode'
import { isFecImportAnalysisComplete } from './isFecImportAnalysisComplete'
import { isFecImportAnalysisFailed } from './isFecImportAnalysisFailed'

interface GetFecImportConfirmationKindParams {
  hasEnteredAnalysingView: boolean
  isRefetchError: boolean
  isTimeoutFetchError: boolean
  sessionFecImports: FecImportItem[]
  sessionImportIds: string[]
}

const getTerminalConfirmationKind = (sessionFecImports: FecImportItem[]): FecImportConfirmationKind | undefined => {
  const failedFecImports = sessionFecImports.filter(isFecImportAnalysisFailed)
  const completedImportCount = sessionFecImports.filter(isFecImportAnalysisComplete).length

  if (completedImportCount + failedFecImports.length !== sessionFecImports.length) {
    return undefined
  }

  if (completedImportCount === sessionFecImports.length) {
    return 'success'
  }

  if (completedImportCount > 0) {
    return 'partial'
  }

  const hasOnlyTimeoutErrors = failedFecImports.every(
    (fecImport) => getFecImportAnalysisErrorCode(fecImport) === FecImportAnalysisErrorCode.Timeout,
  )

  return hasOnlyTimeoutErrors ? 'timeout' : 'all-failed'
}

export const getFecImportConfirmationKind = ({
  hasEnteredAnalysingView,
  isRefetchError,
  isTimeoutFetchError,
  sessionFecImports,
  sessionImportIds,
}: GetFecImportConfirmationKindParams): FecImportConfirmationKind | undefined => {
  if (!hasEnteredAnalysingView) {
    return undefined
  }

  const importCount = sessionFecImports.length

  if (importCount > 0 && importCount === sessionImportIds.length) {
    const terminalKind = getTerminalConfirmationKind(sessionFecImports)

    if (terminalKind) {
      return terminalKind
    }
  }

  if (isRefetchError) {
    return isTimeoutFetchError ? 'timeout' : 'network'
  }

  return undefined
}
